export default __webpack_public_path__ + "static/media/051-the sum of.b5f7d920.svg";